export const COLD_ACCUMULATOR = 1;
export const RUNNING_COLD_REDUCER = -1;
export const FALLING_WET_ACCUMULATOR = 1;
